import axios from "axios";
import { useState, useEffect } from "react";
import LoadingWrapper from "src/components/Loading/LoadingWrapper";
import useCustomToast from "src/hooks/useCustomToast";
import useQueryString from "src/hooks/useQueryString";
import { firmarDocumentos } from "src/services/urls";

const LoadingPage = () => {
    const params = useQueryString()
    const { addWarningToast, addSuccessToast } = useCustomToast();

    const [value, setvalue] = useState({
        loading: false,
        principal: 'Procesando',
        secundario: 'Espere por favor...',
    })

    const init = async () => {
        const idCotizacion = params.idCotizacion
        const { data } = await axios.post(firmarDocumentos(), { idCotizacion, nuevaInterfaz: true })
        if (data.transaccion) {
            window.location.href = data.urlFirma
        }
        else {
            addWarningToast(data.errorDescripcion || 'Error procesando, actualice la página e intente nuevamente')
        }
    }

    useEffect(() => {
        let { loading } = params
        loading = loading === 'true'
        setvalue({
            loading,
            principal: 'Procesando',
            secundario: 'Espere por favor...',
        })

        init()


    }, [])
    return (
        <>
            <LoadingWrapper {...value} >

            </LoadingWrapper>
        </>
    )
}

export default LoadingPage
